import React, { useReducer } from 'react';
import { Routes, Route } from 'react-router-dom';

import Nav from './Nav';
import HomePage from './HomePage';
import BookingPage from './BookingPage';
import ConfirmedBooking from './ConfirmedBooking';

import About from './About';
import Signup from './Signup';
import Gallery from './Gallery';


const initializeTimes = () => {
  return ['17:00', '18:00', '19:00', '20:00', '21:00', '22:00'];
};

const updateTimes = (state, action) => {
  switch (action.type) {
    case 'UPDATE':
      return initializeTimes();
    default:
      return state;
  }
};

function Main() { 
  const [availableTimes, dispatch] = useReducer(updateTimes, initializeTimes());
 

  return (
    <div>
      <Nav />  
  <Routes>
  <Route path="/" element={<HomePage />} />
  <Route path="/portfolio_website" element={<HomePage />} />
  <Route
    path="/booking"
    element={<BookingPage availableTimes={availableTimes} dispatch={dispatch} />}
  />
  <Route path="/confirmed" element={<ConfirmedBooking />} />



  {/* 🔹 Standalone showcase-only page */}


  <Route path="/projects/:category" element={<Gallery />} />
  <Route path="/about" element={<About />} />
  <Route path="/signup" element={<Signup />} />
</Routes>

    </div>
  );
}

export default Main;
